export function setBasePersonName( name ){
    return {
        type: "SET_BASE_PERSON_NAME",
        payload: name
    }
}

export function setBasePersonEmail( email ){
    return {
        type: "SET_BASE_PERSON_EMAIL",
        payload: email
    }
}

export function setBasePersonPhoneNumber( phoneNumber ){
    return {
        type: "SET_BASE_PERSON_PHONE_NUMBER",
        payload: phoneNumber
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/base-person/actions.js